'use client';
function lineHeightResolver(value, theme) {
  if (typeof value === "string" && value in theme.lineHeights) {
    return `var(--mantine-line-height-${value})`;
  }
  return value;
}

export { lineHeightResolver };
//# sourceMappingURL=line-height-resolver.mjs.map
